import * as React from "react"
export const Profile01 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer-11230842081_1"
    data-name="Layer-11230842081 1"
    viewBox="0 0 1151.76 1192.86"

  >
    <defs>
      <clipPath id="clip-path">
        <path
          d="M1057.88 1533.67H95.08c7-97.71 30.52-219.88 97.14-337.4q13-22.93 26.8-43.42c89.36-133.42 231.56-169.47 231.56-169.47 5.36-1.37 9.64-2.32 11.26-2.67 1.6 68.89 60.49 122 125.19 118 60-3.79 109.67-55.82 110.09-119.53 64.81 23.16 164.76 71.09 236.81 173.72 3.79 5.4 13.41 19.8 26.8 43.42 66.63 117.46 90.18 239.68 97.15 337.35Z"
          className="cls-11230842081-1"
        />
      </clipPath>
      <clipPath id="clip-path-11230842081-2">
        <path
          d="M430.48 241.58c-4.22-2.57-55.27-32.58-101.86-8.33-30.38 15.81-41.33 45.56-44.85 55.1-30.32 82.32 51.5 170.46 55.74 174.9l46.13 167.21 1.92-240.24A127.05 127.05 0 0 1 476 364c-22.29 16.33-45.62 36.72-41 49.33 7.84 21.41 91.95 8.55 110.19 5.77 47.83-7.31 116.68-24.82 196-71.11a499.69 499.69 0 0 1 19.22 53.81c20.16 68.63 22.38 130.9 19.22 178.74q17.29-75.92 34.6-151.83c11.52-12.61 59-67.29 53.16-141.86-8.12-104.35-113.22-154.12-132.95-163.46-89.13-42.2-222.17-39.26-277.7 38.17-19.65 27.35-25.05 57.76-26.26 80.02Z"
          className="cls-11230842081-1"
        />
      </clipPath>
      <clipPath id="clip-path-11230842081-7">
        <path
          d="M850.66 1066.78a1076.18 1076.18 0 0 0 132 464.82H734.15a679.06 679.06 0 0 1-56.26-174.25c-14.77-82.74-25.66-138.89 4.76-191.41 50.26-86.8 155.26-98 168.01-99.16Z"
          className="cls-11230842081-1"
        />
      </clipPath>
      <style>
        {
          ".cls-11230842081-1{fill:none}.cls-11230842081-3{fill:#f5b59a}.cls-11230842081-6{fill:#e16b57}.cls-11230842081-7{fill:#17191b}.cls-11230842081-11{clip-path:url(#clip-path-11230842081-2)}.cls-11230842081-12{fill:#fd8710}"
        }
      </style>
    </defs>
    <title>{"Artboard 1"}</title>
    <path
      id="Layer-11230842081_1-2"
      d="M.48-3.77h1152v1542.06H.48z"
      data-name="Layer-11230842081 1"
      style={{
        fill: "#00aebf",
      }}
    />
    <g id="Layer-11230842081_2" data-name="Layer-11230842081 2">
      <path
        d="M476.9 801.29s12 171.78-55.85 286.65c11.44 24.55 60.49 124 142.37 134 95.26 11.55 160.73-107.14 171.2-126.73-14.76-32.31-38.68-94.57-48.76-186.45a810.62 810.62 0 0 1-4.47-106.38Z"
        className="cls-11230842081-3"
      />
      <ellipse
        cx={577.86}
        cy={543.23}
        className="cls-11230842081-3"
        rx={223.07}
        ry={333.43}
      />
      <path d="m509.56 500.39-89.48 6.45c-1.07-3.47-3.19-12.11.95-20.25 2.87-5.65 7.62-8.82 11.84-11 20.48-10.83 76.61-24.84 88.79-3.18a19.45 19.45 0 0 1 2.25 10.82 15.9 15.9 0 0 1-14.35 17.16ZM645.71 501.21l89.57 5.09c1-3.49 3-12.15-1.26-20.23-3-5.6-7.76-8.71-12-10.87-20.64-10.51-77-23.67-88.83-1.82a19.41 19.41 0 0 0-2.08 10.86 15.9 15.9 0 0 0 14.6 16.97Z" />
      <circle
        cx={668.69}
        cy={548.67}
        r={25.35}
        style={{
          isolation: "isolate",
          opacity: 0.64,
        }}
      />
      <circle cx={487.02} cy={548.67} r={25.35} />
      <circle cx={668.7} cy={548.67} r={25.35} />
      <path
        d="M577.11 663c-3.34 0-3.58-6.47-10.5-11.55-4.18-3.07-6.74-2.65-9.38-4.26-4.49-2.73-8.31-10.74-4.81-34.33l10.07-81.45c1.15-9.28 8.8-16.23 17.14-16.38s15.88 6.57 16.73 15.89l7.45 82.18c3.07 22.76-1 30.69-5.57 33.57-3.19 2-6.54 1.52-11.35 5.41-6.33 5.11-6.61 10.92-9.78 10.92Z"
        style={{
          fill: "#e6846b",
        }}
      />
      <path
        d="M578 691.55c-18.59 0-34.07-7.84-37.49-18.23a13.77 13.77 0 0 0-.71 4.32c0 12.45 17.1 22.54 38.19 22.54s38.19-10.09 38.19-22.54a13.77 13.77 0 0 0-.71-4.32C612 683.7 596.55 691.55 578 691.55Z"
        className="cls-11230842081-6"
      />
      <path
        d="M385.82 555.8c27.11 50.87 24.77 122.14-2.29 134.58-22.87 10.52-61-22.12-84.52-42.26-18.88-16.16-31.61-27.06-39.43-46-16.89-40.89-4-102.48 29.58-114.54s77.59 32.42 96.66 68.22Z"
        className="cls-11230842081-3"
      />
      <path
        d="M303.78 541.7a160.58 160.58 0 0 0 5.53 25.56 192.08 192.08 0 0 0 23.79 52.68 143.08 143.08 0 0 0 25.5 29.39 3.08 3.08 0 0 0 4.24 0 3 3 0 0 0 0-4.24C346.31 630.77 334 612.58 325 592.7c-1.91-4.21-3.49-8.08-5.18-12.66q-2.19-5.94-4-12c-1.84-6.12-3.42-12.32-4.67-18.58-.41-2.06-.79-4.13-1.12-6.21-.09-.56-.17-1.13-.25-1.7s.14 1.06 0 .31v-.16a3.09 3.09 0 0 0-3-3c-1.47 0-3.18 1.39-3 3Z"
        className="cls-11230842081-6"
      />
      <path
        d="M277.1 559.19a79 79 0 0 0 7.26 10.46 91.82 91.82 0 0 0 20 18.87 69.49 69.49 0 0 0 16.91 8.5 3 3 0 0 0 1.59-5.79 69 69 0 0 1-25.08-15.75 98.12 98.12 0 0 1-8.41-9.13l-.76-.94c-.15-.18-.29-.37-.43-.55-.48-.62.37.5-.09-.12s-.94-1.25-1.4-1.88c-.8-1.1-1.57-2.21-2.32-3.34s-1.44-2.2-2.07-3.35c-1.88-3.38-7.07-.36-5.19 3Z"
        className="cls-11230842081-6"
      />
      <path
        d="M764 555.8c-27.11 50.87-24.77 122.14 2.29 134.58 22.87 10.52 61-22.12 84.52-42.26 18.88-16.16 31.61-27.06 39.43-46 16.89-40.89 4-102.48-29.58-114.54S783 520 764 555.8Z"
        className="cls-11230842081-3"
      />
      <path
        d="M840 541.7c0 .35-.18 1.09 0-.28-.07.45-.13.9-.19 1.35-.26 1.7-.56 3.4-.88 5.09-1.13 5.92-2.56 11.79-4.22 17.58a184 184 0 0 1-23.06 51.18 137.26 137.26 0 0 1-24.75 28.47 3 3 0 0 0 0 4.24 3.06 3.06 0 0 0 4.24 0c16.92-14.65 29.76-33.57 38.93-53.89a207.53 207.53 0 0 0 14.37-44.54c.61-3 1.16-6.11 1.53-9.2.19-1.61-1.52-3-3-3a3.08 3.08 0 0 0-3 3Z"
        className="cls-11230842081-6"
      />
      <path
        d="M867.49 556.16c-.52.94-1.1 1.85-1.68 2.75s-1.33 2-2 3c-.43.6-.86 1.2-1.3 1.79l-.65.87c-.08.1-.54.71-.08.11l-.5.64a96.68 96.68 0 0 1-8 9 78.59 78.59 0 0 1-10.81 9 63.65 63.65 0 0 1-15.47 7.89 3.08 3.08 0 0 0-2.1 3.69 3 3 0 0 0 3.69 2.1c17.44-5.93 31.83-19.06 41.91-34.23.78-1.17 1.56-2.36 2.24-3.6 1.87-3.37-3.31-6.4-5.19-3Z"
        className="cls-11230842081-6"
      />
      <path d="M681.34 838.63s-49.82 93.9-209.73 87.55l6.05-84.91s87.28 86.16 203.68-2.64Z" />
      <path
        d="M429.22 201.41c7.76 24.68 8.84 55.14 2.57 57.74-5.31 2.2-15.31-15.75-21.49-26.82-5-8.89-8.3-14.88-10.63-23.83-5.05-19.33-3.35-44.55 4.52-46.32s19.57 21.82 25.03 39.23Z"
        className="cls-11230842081-7"
      />
      <path
        d="M409.37 222c26.63 21.7 55.27 49.33 54.63 52.3-.57 2.51-22.05-12.87-35.3-22.37-10.64-7.62-17.81-12.75-27.22-20.68-20.33-17.12-42.8-40.25-40.59-42.61s29.77 18.04 48.48 33.36Z"
        className="cls-11230842081-7"
      />
      <path
        d="M1057.88 1533.67H95.08c7-97.71 30.52-219.88 97.14-337.4q13-22.93 26.8-43.42c89.36-133.42 231.56-169.47 231.56-169.47 5.36-1.37 9.64-2.32 11.26-2.67 1.6 68.89 60.49 122 125.19 118 60-3.79 109.67-55.82 110.09-119.53 64.81 23.16 164.76 71.09 236.81 173.72 3.79 5.4 13.41 19.8 26.8 43.42 66.63 117.46 90.18 239.68 97.15 337.35Z"
        style={{
          fill: "#fff",
        }}
      />
      <g
        style={{
          clipPath: "url(#clip-path)",
        }}
      >
        <path
          d="M94.4 1011.99h965.53v110.95H94.4z"
          style={{
            fill: "#b5af87",
          }}
        />
      </g>
      <circle cx={727.34} cy={602.8} r={12.31} className="cls-11230842081-6" />
      <circle cx={686.21} cy={613.99} r={12.31} className="cls-11230842081-6" />
      <circle cx={715.4} cy={639.11} r={12.31} className="cls-11230842081-6" />
      <circle cx={430.37} cy={602.8} r={12.31} className="cls-11230842081-6" />
      <circle cx={471.51} cy={613.99} r={12.31} className="cls-11230842081-6" />
      <circle cx={442.31} cy={639.11} r={12.31} className="cls-11230842081-6" />
      <path
        d="M430.48 241.58c-4.22-2.57-55.27-32.58-101.86-8.33-30.38 15.81-41.33 45.56-44.85 55.1-30.32 82.32 51.5 170.46 55.74 174.9l46.13 167.21 1.92-240.24A127.05 127.05 0 0 1 476 364c-22.29 16.33-45.62 36.72-41 49.33 7.84 21.41 91.95 8.55 110.19 5.77 47.83-7.31 116.68-24.82 196-71.11a499.69 499.69 0 0 1 19.22 53.81c20.16 68.63 22.38 130.9 19.22 178.74q17.29-75.92 34.6-151.83c11.52-12.61 59-67.29 53.16-141.86-8.12-104.35-113.22-154.12-132.95-163.46-89.13-42.2-222.17-39.26-277.7 38.17-19.65 27.35-25.05 57.76-26.26 80.02Z"
        className="cls-11230842081-7"
      />
      <path
        d="M355.73 222.91q3.22.1 6.45.39c1.36.12 2.72.26 4.07.43l1.13.14h-.29l.52.07c.81.12 1.63.24 2.44.38a118.48 118.48 0 0 1 22.66 6.08c1 .36 1.89.73 2.83 1.11l.71.29c-.84-.35 0 0 .18.08l1.8.8q3.24 1.47 6.38 3.13a112 112 0 0 1 13.1 8.17c.56.4 1.11.81 1.66 1.23l.73.56.19.15c1.09.87 2.18 1.75 3.24 2.66q3.06 2.61 5.93 5.44a116.79 116.79 0 0 1 9.54 10.61c.76 1-.34-.46.11.14l.57.75c.37.49.73 1 1.09 1.48.7 1 1.38 1.93 2 2.91 1.24 1.82 2.42 3.68 3.55 5.56q2.81 4.68 5.15 9.6a4.52 4.52 0 0 0 6.16 1.61 4.62 4.62 0 0 0 1.61-6.16 116.3 116.3 0 0 0-32.95-41.29A118.78 118.78 0 0 0 374.85 216a128 128 0 0 0-19.12-2.12 4.53 4.53 0 0 0-4.5 4.5 4.6 4.6 0 0 0 4.5 4.51ZM745.85 356.88a182.58 182.58 0 0 0-27.51-43.1 186.25 186.25 0 0 0-38.09-33.84 176.27 176.27 0 0 0-24.82-13.86c-2.14-1-4.94-.68-6.16 1.61-1 2-.67 5.11 1.61 6.16a177.31 177.31 0 0 1 21.91 11.95q5.22 3.34 10.19 7.05l1.24.93.62.47c.1.08.75.57.31.24l.16.12.61.48 1.52 1.2c1.61 1.29 3.2 2.62 4.76 4a183.26 183.26 0 0 1 17.63 17.4q2.05 2.33 4 4.71c.66.8 1.31 1.6 1.95 2.41l1 1.22.48.61c-.26-.34-.24-.32 0 0q3.81 5 7.3 10.25a175.67 175.67 0 0 1 13.54 24.56c1 2.15 4.26 2.84 6.16 1.61a4.63 4.63 0 0 0 1.6-6.15ZM450.72 385.87q4.13-3.86 8.42-7.54c1.52-1.3 3.06-2.59 4.61-3.85l2.32-1.87 1.19-.94c.17-.14 1.36-1.06.81-.64a248.53 248.53 0 0 1 46.21-28.17c1.83-.86 3.67-1.69 5.52-2.51l2.72-1.18c.82-.35.26-.11.08 0l.58-.24 1.72-.71q5.25-2.15 10.59-4 10.77-3.84 21.85-6.7a4.5 4.5 0 0 0-2.4-8.68 261.4 261.4 0 0 0-42.24 14.95 248.52 248.52 0 0 0-47.07 27.93 262.87 262.87 0 0 0-21.29 17.85 4.54 4.54 0 0 0 0 6.36 4.6 4.6 0 0 0 6.38 0ZM324.48 455.62a58.09 58.09 0 0 0 41.35 14.85 4.58 4.58 0 0 0 4.5-4.5c-.1-2.34-2-4.63-4.5-4.5-1.7.08-3.39.1-5.09 0-.88 0-1.76-.1-2.64-.19l-1.21-.13c-1-.11.67.12-.42-.06a58.44 58.44 0 0 1-9.67-2.41c-.77-.27-1.53-.56-2.29-.86l-.57-.23c.39.16.43.18.14.05l-1.3-.59c-1.47-.69-2.92-1.45-4.32-2.28s-2.77-1.71-4.09-2.66c-.33-.24-.66-.48-1-.73.71.53-.23-.18-.37-.3-.74-.6-1.46-1.22-2.17-1.85a4.57 4.57 0 0 0-6.36 0c-1.58 1.72-1.88 4.69 0 6.37ZM822.22 417q-1.22 2-2.59 3.87l-.7.93c.58-.75-.13.15-.26.31-.49.6-1 1.2-1.51 1.78a56.13 56.13 0 0 1-6.88 6.56l-.46.36c.35-.27.4-.3.14-.11l-.94.7c-.63.46-1.27.9-1.91 1.33q-1.93 1.29-4 2.42t-4.11 2.04l-.53.24c.42-.17.48-.2.18-.08l-1.08.43c-.78.3-1.58.59-2.37.86-2.22.75-3.92 3.13-3.14 5.54.72 2.21 3.15 3.95 5.54 3.14A61.08 61.08 0 0 0 830 421.5a4.56 4.56 0 0 0-1.61-6.16 4.61 4.61 0 0 0-6.16 1.62Z"
        className="cls-11230842081-11"
      />
      <path
        d="M850.66 1066.78a1076.18 1076.18 0 0 0 132 464.82H734.15a679.06 679.06 0 0 1-56.26-174.25c-14.77-82.74-25.66-138.89 4.76-191.41 50.26-86.8 155.26-98 168.01-99.16Z"
        className="cls-11230842081-12"
      />
      <g
        style={{
          clipPath: "url(#clip-path-11230842081-7)",
        }}
      >
        <path
          d="M462.8 911.31a117.73 117.73 0 0 0 13.08 78.08c12.8 22.86 33.57 40.55 57.79 50.35 25.11 10.15 52.81 10.62 78.69 3 26.88-7.87 50.91-23.45 70.9-42.86 20.35-19.77 36.73-43.25 51.19-67.54q2.65-4.47 5.25-9a1.5 1.5 0 0 0-2.59-1.51C723.31 946 708 969.4 689.05 989.74c-18.72 20.07-41.16 36.88-67 46.64-24.91 9.41-52.22 11.72-77.88 3.92-24.24-7.37-46.06-22.9-60.41-43.84a114.85 114.85 0 0 1-19.43-74.52c.29-3.29.75-6.56 1.34-9.81.34-1.91-2.55-2.72-2.9-.82Z"
          style={{
            fill: "#874203",
          }}
        />
      </g>
      <path
        d="M659.46 1245.06a303.3 303.3 0 0 0 74.62-35.66c70-46.25 102.89-110.33 116.59-142.62a594.78 594.78 0 0 1-181.19 127.55 186.64 186.64 0 0 0-10 50.73Z"
        style={{
          opacity: 0.4,
          isolation: "isolate",
        }}
      />
      <path
        d="M379.76 1012a131.63 131.63 0 0 0-7.05 35.45c-5.21 91.61 90 172.3 156.29 193.7 12.48 4 41.71 11.7 71.92 11.26 18.23-.27 38.52-3.51 40.37-3.81 7.39-1.2 13.59-2.49 18.17-3.53a185.82 185.82 0 0 1 10-50.72c-23.77 7.14-76.43 19.12-135.57-.6-120.27-40.11-152.16-172.94-154.13-181.75Z"
        style={{
          opacity: 0.44,
          isolation: "isolate",
        }}
      />
      <path
        d="M684.94 899.88c6.3-1.22 15.38-1.88 23.6 2.62 11.79 6.46 13.37 19 18.94 28.76 13.67 24.1 46.69 21.47 69.13 32 24.27 11.42 52.71 37.73 67.23 104.46a506.45 506.45 0 0 1-11.26 10C794.51 1128 698.49 1211 589.16 1204.93c-100.6-5.62-200.17-86-209.24-168.28-3.72-33.7 7.68-94 50.71-117.28 15.44-8.36 31.07-9.81 42.17-9.61l-.93 13a88.05 88.05 0 0 0 .2 12s2.6 30.62 25.1 56.71c34.53 40 129.35 45 167.24-.67 18.26-22 24.51-57.32 23.36-66.26-.06-.46-.81-6-1.67-13.72-.55-4.82-.94-8.65-1.16-10.94Z"
        className="cls-11230842081-12"
      />
    </g>
  </svg>
)

